<template>
  <div class="contact-area">
    <div class="contact" :style="{ background: value.socialMediaIcons?.sectionColor?.backGround }"  :class="{ 'is-open': contactOpen, 'is-closed': !contactOpen }">
      <main>
        <section :style="{ background: value.baseInfo?.sectionColor?.backGround }">
          <div class="header-content">
            <div class="profile-row">
              <img
                v-if="value.photo?.profile"
                :src="value.photo.profile"
                alt="Profile Image"
                class="profile-img"
              />
              <aside :style="{ color: value.baseInfo?.sectionColor?.text }">
                <h1 v-if="value.organizationName">
                  {{ value.organizationName }}
                </h1>
              </aside>
            </div>

            <div
              :style="{ color: value.baseInfo?.sectionColor?.text }"
              class="about-text text-justify"
              style="white-space: pre-line"
              v-html="value.aboutUs"
            ></div>
          </div>

          <v-btn 
            ref="contactBtn" 
            @click="toggleMedia"  
            :class="['elevation-8 py-0 glass-effect', showMedia ? 'active-btn' : 'closed-btn']"                    
            :style="{
              background: value.socialMediaIcons?.sectionColor?.backGround,
              color: value.socialMediaIcons?.sectionColor?.text + ' !important',
            }"      
          >              
            <span class="btn-text">{{ value.buttonName || '' }}</span>

            <svg
              height="28"
              viewBox="0 0 48 48"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g class="nc-icon-wrapper" fill="#ffffff">
                <path d="M14.83 30.83L24 21.66l9.17 9.17L36 28 24 16 12 28z"></path>
              </g>
            </svg>
          </v-btn>
        </section>
      </main>

      <nav :class="showMedia ? 'active' : ''">
        <a
          v-for="(item, i) in displayedMedias"
          :key="i"
          :style="{
            background: hexToRgba(value.socialMediaIcons?.sectionColor?.backGround, 0.4),
            color: value.socialMediaIcons?.sectionColor?.text + ' !important',
          }"
          class="social-item glass-effect cursor-pointer"
          @click="handleClick(item)"
        >
        <div class="icon">
          <svg-base :view-box="getViewBox(item.name)" style="display: block; margin: auto;">
            <component :is="item.svg" class="mt-0" />
          </svg-base>
        </div>
           <div class="item-text-content">
            <span class="mb-2">{{ item.label }}</span>
            <span v-if="item.pattern === ''" dir="ltr" class="link-text mb-2">
              {{ item.prefix === "@" ? item.prefix : "www." }}{{ item.url }}
            </span>
            <span v-if="item.pattern !== ''" dir="ltr" class="link-text mb-2">
              {{ item.pattern }}{{ item.url }}
            </span>
            <span v-if="item.socialText" class="link-text">{{ item.socialText }}</span>
          </div>

          <svg
            class="arrow"
            height="22"
            style="transform: rotate(180deg) !important"
            viewBox="0 0 48 48"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g class="nc-icon-wrapper" fill="#ffffff">
              <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path>
            </g>
          </svg>
        </a>
        <div v-if="medias.length > initialLimit" class="toggle-container w-100 mt-4 mb-2">
          <div class="divider-line"></div>
          <button class="toggle-btn glass-effect" @click="isListExpanded = !isListExpanded">
            <v-icon small color="white" class="mr-1">
              {{ isListExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
            <span>{{ isListExpanded ? 'نمایش کمتر' : 'نمایش بیشتر' }}</span>
          </button>
          <div class="divider-line"></div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import SvgBase from "@/view/content/svgLoader/svgBase";
const viewBoxConfig = {
  // شبکه‌های اجتماعی ایرانی
  aparat: 40,
  gap: 40,

  // شبکه‌های اجتماعی خارجی
  linkedin_company: '-10 -10 60 60',
  github: 32,
  threads: 42,
  skype: 40,
  youtube: 40,
  wechat: 40,
  viber: 40,

  // سایت‌های آگهی و فروشگاهی
  divar: '0 0 40 24.33',
  sheypoor: 40,
  digikala: '0 0 1200 1200',
  basalam: '0 -15 128 128',
  snappshop: '-10 -20 80 80',    
  technolife: '0 -40 100 100',
  torob: '0 -20 200 200',        
  emalls: '0 -80 310 310',

  // استورها
  cafebazaar: '-10 -70 370 370',
  googleplay: '0 -4.447 361.403 408.86699999999996',
  samsung: '0 0 230 230',
  apple: '0 0 512 512',
};

export default {
  name: "SocialExpandable",
  components: {
    SvgBase,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({})
    },
    medias: {
      type: Array,
      required: true,
      default: () => []
    },
    contactOpen: { 
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showMedia: false,
      isListExpanded: false,
      initialLimit: 4
    };
  },
  computed: {
    
    displayedMedias() {
      if (this.isListExpanded) {
        return this.medias;
      }
      return this.medias.slice(0, this.initialLimit);
    }
  },
  methods: {
  getViewBox(name) {
      return viewBoxConfig[name] || '0 0 50 50';
    },
        hexToRgba(hex, opacity) {
      if (!hex) return 'transparent';
      let c;
      if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c = hex.substring(1).split('');
        if(c.length === 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
      }
      return hex; 
    },
    toggleMedia() {
      this.showMedia = !this.showMedia;
      if (this.showMedia) {
        setTimeout(() => {
          const scrollContainer = document.querySelector('.overflow-y-auto');
          if (scrollContainer) {
            scrollContainer.scrollTo({
              top: scrollContainer.scrollHeight,
              behavior: 'smooth'
            });
          }
        }, 500); 
      } else {
        // بازنشانی وضعیت نمایش بیشتر هنگام بستن
        this.isListExpanded = false;
      }
    },
    handleClick(item) {
      this.$emit("go-to-url", item.url, item.pattern);
    }
  },
};
</script>

<style lang="scss" scoped>
$color-2: #c63535;

@mixin transform($transform) {
  -webkit-transform: $transform;
  transform: $transform;
}
@mixin transition($transition) {
  -webkit-transition: #{$transition};
  transition: #{$transition};
}

.contact-area {
  width: calc(100%-9px);
  padding: 8px 12px;
  box-sizing: border-box;
  overflow-y:hidden;
  padding-bottom: 25px !important;
}

.contact {
  width: 100%;
  border-radius: 20px;
  position: relative;
  box-sizing: border-box;
  overflow: visible !important;
  transition: padding-bottom 0.3s ease; 

  &.is-closed {
    padding-bottom: 35px !important;
  }

  &.is-open {
    padding-bottom: 5px !important; 
  }
  main {
    width: 100%;
    position: relative;

    section {
      width: 100%;
      position: relative;
      border-radius: 20px;
      padding-bottom: 28px; /* جا برای قرار گرفتن نصف دکمه */

      .header-content {
        padding: 20px 16px 16px 16px;
        width: 100%;
        box-sizing: border-box;

        .profile-row {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 12px;

          .profile-img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            object-fit: cover;
            flex-shrink: 0;
          }

          aside {
            flex: 1;
            h1 {
              font-size: 18px !important;
              font-weight: bold;
              margin: 0;
            }
          }
        }

        .about-text {
          font-size: 14px;
          line-height: 1.8;
          opacity: 0.9;
        }
      }
    }

    button {
      position: absolute;
      bottom: -22px;
      border: 0;
      text-align: center;
      @include transition(all 0.4s cubic-bezier(0.4, 0, 0.2, 1));
      outline: none;
      z-index: 10;

      &.closed-btn {
        width: calc(100% - 40px);
        left: 20px;
        right: 20px;
        height: 44px;
        border-radius: 24px;

        .btn-text {
          opacity: 1;
          display: block;
        }

        svg {
          display: none;
        }
      }

      &.active-btn {
        right: 20px;
        left: auto;
        width: 44px;
        height: 44px;
        min-width: 44px !important;
        padding: 0 !important;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-text {
          display: none;
        }

        svg {
          display: block;
          margin: auto;
        }
      }
    }
  }

  nav {
    width: calc(100%-8px);
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    padding: 0 5px;
    box-sizing: border-box;
    @include transition(all 0.4s ease);

    &.active {
      max-height: 2500px; /* افزایش max-height برای جا دادن آیتم‌های بیشتر */
      opacity: 1;
      padding-top: 32px; /* فاصله از دکمه */
      padding-bottom: 20px;

      .social-item {
        opacity: 1;
        @include transform(translateY(0));
      }
    }

    .social-item {
      display: flex;
      align-items: center;
      width: calc(100%-8px);
      min-width: calc(100%-8px);
      margin: 12px 0;
      padding: 10px 5px;
      border-radius: 12px;
      text-decoration: none;
      opacity: 0;
      @include transform(translateY(-10px));
      @include transition(all 0.3s ease);

      .icon {
        flex: 0 0 42px;
        height: 42px;
        border-radius: 50%;
        overflow: hidden;
        margin-left: 2px; 
        margin-right: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      .item-text-content {
        flex: 1;
        min-width: 0;
        text-align: right;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h1 {
          font-size: 14px;
          font-weight: bold;
          margin: 0 0 2px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 80%;
        }

        .link-text {
          font-size: 12px;
          opacity: 0.8;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          direction: ltr;
          text-align: right;
          width: 180px;
        }
      }

      .arrow {
        flex: 0 0 20px;
        opacity: 0.7;
      }
    }

    .toggle-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      padding: 0 8px;

      .divider-line {
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
      }

      .toggle-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 6px 16px;
        border-radius: 20px;
        font-size: 0.8rem;
        font-weight: 500;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.15);
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        &:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: translateY(-2px);
        }
        
        span {
          margin-top: 2px;
        }
      }
    }
  }
}

.cursor-pointer { cursor: pointer; }
.glass-effect {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

* { font-family: 'Vazirmatn', Tahoma, sans-serif !important; }
.content-text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 12px;
  overflow: hidden;
  width: 90%;
  box-sizing: border-box;

  .title-text {
    width: 80%;
    font-size: 0.95rem;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.2;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .url-text {
    width: 80%;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.2;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: ltr;
    text-align: right;
  }
}

</style>
